import { Stack, Typography } from '@mui/material'
import { StoreBizHour } from 'models'
import { FC } from 'react'
import { convert24hrTo12hr } from 'services'

interface BizHourDisplayProps {
  bizHour: StoreBizHour
}

export const BizHourDisplay: FC<BizHourDisplayProps> = ({ bizHour }) => {
  return (
    <Stack spacing={2}>
      {bizHour.from_1 && bizHour.to_1 && (
        <Typography variant="body2">
          {convert24hrTo12hr(bizHour.from_1)} -{' '}
          {convert24hrTo12hr(bizHour.to_1)}
        </Typography>
      )}
      {bizHour.from_2 && bizHour.to_2 && (
        <Typography variant="body2">
          {convert24hrTo12hr(bizHour.from_2)} -{' '}
          {convert24hrTo12hr(bizHour.to_2)}
        </Typography>
      )}
    </Stack>
  )
}
